import { SET_COMMENTLIST } from '../actions';

const commentlist = (state = [], action) => {
  switch (action.type) {
	case SET_COMMENTLIST:
      return [...action.value];  
    default: return state;
  }
}

export default commentlist;
